import { COOKIES } from "constants/cookies";
import { isGCXDomain } from "./window";

const MILISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;

export const getCookie = (key) =>
  document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`)?.pop() || "";

export const setCookie = ({ name, value, days = 1 }) => {
  const date = new Date();
  date.setTime(date.getTime() + days * MILISECONDS_IN_A_DAY);
  const expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "") + expires + "; path=/;";
};

export const eraseCookie = (name) => {
  document.cookie = name + "=; Max-Age=0; path=/;";
};

export const getGlobalBannerCookie = () =>
  getCookie(COOKIES.GLOBAL_PROMO_BANNER);

export const getSiteBannerCookie = () => getCookie(COOKIES.SITE_BANNER);

export const setSiteBannerCookie = () => {
  setCookie({ name: COOKIES.SITE_BANNER, value: "shown", days: 1 });
};

export const setReturnToCookie = (href) => {
  const url = new URL(href);
  const cookieValue = isGCXDomain() ? url.href : url.pathname;
  document.cookie = `${COOKIES.RETURN_TO}=${cookieValue}`;
};
